import * as React from 'react';
import * as autoBind from 'react-autobind';
import {BasicModal} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import ValueProp from './ValueProp';

export default class ValuePropModal extends React.Component<ValuePropModalProps, {}> {
   constructor(props: ValuePropModalProps) {
      super(props);
      autoBind(this);
   }

   render() {
      const {onClose, themeName, bannerText, valuePropModalGraphic, bodyText, bodySubText, benefitList, testId, children} = this.props;

      return (
         <BasicModal themeName={themeName} title={bannerText} onClose={onClose} visible={true} testId={testId}>
            <ValueProp benefitList={benefitList} bodyText={bodyText} bodySubText={bodySubText} children={children} valuePropModalGraphic={valuePropModalGraphic}/>
         </BasicModal>
      );
   }
}

interface ValuePropModalProps extends Themeable {
   bannerText: string;
   valuePropModalGraphic?: React.ReactNode;
   children?: React.ReactNode;
   bodyText?: string | JSX.Element;
   bodySubText?: string;
   benefitList: string[];
   testId?: string;
   onClose(): void;
}
